<template>
	<div class="time-range">
		<egranty-section-divider 
			:text="numberOfModules > 1 ? 'Ramy czasowe modułu ' + moduleNumber : 'Ramy czasowe projektu'"
			icon="date_range"
			:show-print-info="showPrintInfo"
		></egranty-section-divider>

		<div class="ml-1 mt-3 mr-3 module-dates" style="width: 800px">
			<egranty-date-picker
				:disabled="readonly"
				v-model=data.start
				:label="numberOfModules > 1 ? 'Data rozpoczęcia modułu' : 'Data rozpoczęcia projektu'"
				for="choose-start-end-date-start-module"
				id="choose-start-end-date-start-module"
				@input='syncAndCleanErrors'
				:min="minDate"
				:max="maxDate"
			></egranty-date-picker>

			<egranty-date-picker
				:disabled="readonly"
				v-model=data.end
				:label="numberOfModules > 1 ? 'Data zakończenia modułu' : 'Data zakończenia projektu'"
				for="choose-start-end-date-end"
				id="choose-start-end-date-end"
				@input="syncAndCleanErrors"
				:min="minDate"
				:max="maxDate"
			></egranty-date-picker>
			<egranty-validation-error
				:error="error"
			></egranty-validation-error>
		</div>
	</div>
</template>

<script>
	import EgrantyDatePicker from "../../../../genericComponents/EgrantyDatePicker";
	import EgrantySectionDivider from "../../../../genericComponents/EgrantySectionDivider";
	import EgrantyValidationError from "../../../../genericComponents/EgrantyValidationError";

	export default {

		data() {
			return {
				data: {
					start: "",
					end: "",
				},

				error: ""
			};
		},

		name: "ChooseStartEnd",
		components: {EgrantyValidationError, EgrantySectionDivider, EgrantyDatePicker},

		watch: {
			value: {
				immediate: true,
				handler(val) {
					if (val !== undefined)
						this.data = val;
				},
			}
		},

		methods: {
			validate() {
				if (!this.data.start || !this.data.end) {
					if (this.numberOfModules > 1) {
						this.error = "Proszę podać daty początku i końca modułu";
					} else {
						this.error = "Proszę podać daty początku i końca projektu";
					}
				} else if (this.data.start >= this.data.end) {
					if (this.numberOfModules > 1) {
						this.error = "Data początku modułu musi być wcześniejsza od daty końca modułu";
					} else {
						this.error = "Data początku projektu musi być wcześniejsza od daty końca projektu";
					}
				}
				return this.error === "";
			},

			syncAndCleanErrors() {
				this.error = "";
				this.$emit('input', this.data);
			}
		},

		props: {
			readonly: {
				default: false
			},
			numberOfModules: {
				default: 0
			},
			moduleNumber: {
				default: ''
			},
			value: Object,
			minDate: String,
			maxDate: String,
			showPrintInfo: {
				type: Boolean, default: false
			}
		},
	};
</script>

<style scoped>

</style>
